var React = require('react');

function Marker (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;}.b{fill:#fff;}")),React.createElement("path",{"className":"a","d":"M0,0H55.145V55.145H0Z","key":1}),React.createElement("path",{"className":"b","d":"M23.679,45.426,35.053,34.053a16.084,16.084,0,1,0-22.747,0Zm0,6.5L9.057,37.3a20.679,20.679,0,1,1,29.245,0Zm0-24.65a4.6,4.6,0,1,0-4.6-4.6A4.6,4.6,0,0,0,23.679,27.274Zm0,4.6a9.191,9.191,0,1,1,9.191-9.191A9.191,9.191,0,0,1,23.679,31.87Z","transform":"translate(3.893 2.595)","key":2})]);
}

Marker.defaultProps = {"width":"55.145","height":"55.145","viewBox":"0 0 55.145 55.145"};

module.exports = Marker;

Marker.default = Marker;
